angular
  .module('surfsightApp.controllers')
  .controller('dashcamLiveVideoControllerDeprecated', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$mdToast',
    '$mdColors',
    '$localStorage',
    'edgeFactory',
    '$filter',
    '$q',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $mdToast,
      $mdColors,
      $localStorage,
      edgeFactory,
      $filter,
      $q
    ) {
      const hlsPlayer = require('../js/single_hls')
      const webrtcPlayer = require('../js/single_webrtc')

      const defaultPlayerType = 'webrtc'
      const dashcamHLSfilename = 'playlist.m3u8'
      let currentPlayerType = null

      let mediaToken = $scope.dashcamStream.mediaToken
      const serialNumber = $scope.dashcamStream.serialNumber
      const streamId = $scope.dashcamStream.streamId
      const videoElementId = `${serialNumber}-${streamId}`

      let currentPlayerInstance = null
      let changePlayerTypeTimeout = null
      let changePlayerTypeHttpRequstTimeout = null
      $scope.dashcamStreamDisplay = {
        serialNumber,
        cameraName: $scope.dashcamStream.cameraName || serialNumber,
        streamId: streamId,
        streamName: window.getCameraNameByStreamId(
          $filter('translate'),
          edgeFactory.list.find(e => e.uri === serialNumber),
          streamId
        )
      }
      $scope.videoElementId = videoElementId
      $scope.playerStatus = {
        playPause: true,
        maximized: false
      }
      $scope.hoveringVideoElement = false
      $scope.toggleVideoElement = true

      let videoSource = null
      const playLiveVideo = function () {
        if (currentPlayerType === 'webrtc') {
          currentPlayerInstance = webrtcPlayer.player({
            videoElementId,
            videoSource
          })
        } else if (currentPlayerType === 'hls') {
          currentPlayerInstance = hlsPlayer.player({
            videoElementId,
            videoSource
          })
        }
      }
      const stopLiveVideo = function () {
        changePlayerTypeTimeout &&
          $timeout.cancel(changePlayerTypeTimeout) &&
          (changePlayerTypeTimeout = null)
        changePlayerTypeHttpRequstTimeout &&
          changePlayerTypeHttpRequstTimeout.resolve() &&
          (changePlayerTypeHttpRequstTimeout = null)
        if (currentPlayerInstance) {
          currentPlayerInstance.stop()
          currentPlayerInstance = null
        }
        $timeout(function () {
          $scope.toggleVideoElement = false
          $timeout(function () {
            $scope.toggleVideoElement = true
          })
        })
      }
      const goFullScreen = function () {
        try {
          const elem = document.getElementById(`remoteVideo-${videoElementId}`)
          if (elem.requestFullscreen) {
            elem.requestFullscreen()
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen()
          } else if (elem.webkitEnterFullScreen != undefined) {
            elem.webkitEnterFullScreen() // Safari
          }
        } catch (e) {
          console.error(e)
        }
      }
      $scope.changePlayerType = async function (
        playerType = defaultPlayerType
      ) {
        if (edgeFactory.list.find(e => e.uri === serialNumber).standby) {
          return false
        }
        changePlayerTypeTimeout &&
          $timeout.cancel(changePlayerTypeTimeout) &&
          (changePlayerTypeTimeout = null)
        if (!$scope.playerStatus.playPause) {
          return false
        }
        stopLiveVideo()
        changePlayerTypeHttpRequstTimeout = $q.defer()
        currentPlayerType = playerType
        $scope.currentPlayerType = currentPlayerType
        const requestJson = {
          method: 'POST',
          url: `${MEDIACORE_BASEURL}/browser`,
          data: {
            edgeid: serialNumber
          },
          timeout: changePlayerTypeHttpRequstTimeout.promise
        }
        try {
          // update mediacore
          const dashcamMediacoreResponse = await $http(requestJson)
          if (dashcamMediacoreResponse.data.status.code === 0) {
            const mediacore = dashcamMediacoreResponse.data.HLS_server_address
            if (playerType === 'webrtc') {
              videoSource = `https://${mediacore}/webrtc/#PEERID#/${serialNumber}/${streamId}/${mediaToken}`
            } else if (playerType === 'hls') {
              videoSource = `https://${mediacore}/${serialNumber}/${streamId}/${mediaToken}/${dashcamHLSfilename}`
            }
            playLiveVideo()
          }
        } catch (error) {
          if (error.xhrStatus !== 'abort') {
            changePlayerTypeTimeout = $timeout(() => {
              $scope.changePlayerType(currentPlayerType)
            }, 1500)
          }
        } finally {
          changePlayerTypeHttpRequstTimeout = null
        }
      }
      $scope.changePlayerType()
      $scope.togglePlayerType = function () {
        $scope.displayOptions.showPlayerTypeOptions = false
        $timeout(function () {
          currentPlayerType = $scope.displayOptions.currentPlayerType
          $scope.playerStatus.playPause = true
          $scope.changePlayerType(currentPlayerType)
        })
      }
      $scope.showPlayerTypeOptions = function () {
        $scope.displayOptions.showPlayerTypeOptions = !$scope.displayOptions
          .showPlayerTypeOptions
      }

      $scope.$watch(
        () => $scope.playerStatus.playPause,
        newValue => {
          const liveVideoTimeoutSeconds =
            ($localStorage.userOrganization &&
              $localStorage.userOrganization.liveVideoTimeoutSeconds) ||
            30
          if (liveVideoTimeoutSeconds > 0) {
            if (!newValue && $scope.pauseInterval) {
              $interval.cancel($scope.pauseInterval)
            }
            if (newValue) {
              $scope.pauseInterval = $interval(() => {
                console.warn(
                  'Terminating video due to timeout after %d seconds',
                  liveVideoTimeoutSeconds
                )
                $scope.playPause()
              }, liveVideoTimeoutSeconds * 1000)
            }
          }
        }
      )
      $scope.playPause = function () {
        const currentPlayerStatus = $scope.playerStatus.playPause
        $scope.playerStatus.playPause = !$scope.playerStatus.playPause
        if (currentPlayerStatus) {
          stopLiveVideo()
        } else {
          $scope.changePlayerType(currentPlayerType)
        }
      }
      $scope.fullScreen = function () {
        goFullScreen()
      }
      $scope.shareDashcamLiveVideo = e => {
        $scope.callback({
          type: 'shareDashcamLiveVideo',
          dashcamStream: $scope.dashcamStream,
          data: {}
        })
      }
      $scope.closeDashcamLiveVideo = e => {
        $scope.callback({
          type: 'closeDashcamLiveVideo',
          dashcamStream: $scope.dashcamStream,
          data: {}
        })
      }
      $scope.displayOptions = {
        playerType: true,
        showPlayerTypeOptions: false,
        currentPlayerType: defaultPlayerType,
        fullScreen: true,
        playPause: true,
        share: false,
        closeVideo: true
      }
      $scope.$on('restartVideo', function (e, data) {
        if (data.videoElementId === videoElementId) {
          stopLiveVideo()
          $scope.changePlayerType(currentPlayerType)
        }
      })
      $scope.$on('updateMediaToken', (e, data) => {
        mediaToken = data.mediaToken // update media token
        $scope.playerStatus.playPause &&
          $scope.changePlayerType(currentPlayerType)
      })
      $scope.$on('$destroy', function () {
        $scope.pauseInterval && $interval.cancel($scope.pauseInterval)
        $scope.playerStatus.playPause = false
        stopLiveVideo()
      })
    }
  ])
